import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { ResourceNames } from '@/lib/constants';
import * as actions from '@/store/senderBuild/actions';
import type { MutationOptionsType } from '../../envelope/query-helpers';
import { applyTemplatesInBulk } from '../../template/template-api';

type Body = Parameters<typeof applyTemplatesInBulk>[1];

export function useApplyTemplatesInBulk(
  envelopeId: string,
  options?: MutationOptionsType<typeof applyTemplatesInBulk, Body>
) {
  const dispatch = useDispatch();
  return useMutation({
    ...options,
    async mutationFn(body) {
      const res = await applyTemplatesInBulk(envelopeId, body);

      // After a template is applied, refetch the envelope info so that the template blocks appear
      dispatch(actions.fetch(envelopeId, ResourceNames.ENVELOPE));

      return res;
    },
  });
}
